import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";
import {SiteAppComponent} from "./site-app.component";
import {HomeComponent} from "../+home/home.component";
import {NewsComponent} from "../+news/news.component";
import {CatalogsComponent} from "../+catalogs/catalogs.component";
import {ContactsComponent} from "../+contacts/contacts.component";
import {ProductsComponent} from "../+products/products.component";
import {VideoComponent} from "../+video/video.component";
import {PartnersComponent} from "../+partners/partners.component";

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: SiteAppComponent,
        children : [
          {
            path: '',
            component: HomeComponent
          },
          {
            path: 'news',
            component: NewsComponent
          },
          {
            path: 'catalogs',
            component: CatalogsComponent
          },
          {
            path: 'contacts',
            component: ContactsComponent
          },
          {
            path: 'products',
            component: ProductsComponent
          },
          {
            path: 'video',
            component: VideoComponent
          },
          {
            path: 'partners',
            component: PartnersComponent
          }
        ]
      },
    ])
  ]
})
export class SiteAppRoutingModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+site-app/site-app-routing.module.ts